import { render } from "./ProjectSwitcher.vue?vue&type=template&id=2f1c3c92"
import script from "./ProjectSwitcher.vue?vue&type=script&lang=js"
export * from "./ProjectSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__